/**
 * Payment methods types.
 */
export enum PaymentMethod {
  Card = 'credit-card',
  Ach = 'ach',
  Cash = 'cash',
  Check = 'check',
}
